import React, { useState } from "react";
import { Send } from "lucide-react";

export function ChatComposer({ onSend, busy }) {
  const [input, setInput] = useState("");
  const submit = () => {
    const text = input.trim();
    if (!text || busy) return;
    setInput("");
    onSend(text);
  };
  return (
    <div className="border-t border-white/10 p-3">
      <div className="flex gap-2">
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="Say something… ? or @bot for AI"
          data-testid="chat-input"
          disabled={busy}
          className="min-w-0 flex-1 rounded-md border border-white/10 bg-black/60 px-3 py-2 text-sm sm:px-4 text-slate-100 placeholder:text-slate-500 focus:border-cyan-400/60 focus:outline-none"
        />
        <button onClick={submit} disabled={busy || !input.trim()} data-testid="chat-send" className="inline-flex shrink-0 items-center gap-2 rounded-md bg-cyan-500 px-4 py-2 text-sm font-semibold text-black hover:bg-cyan-400 disabled:opacity-50">
          <Send size={12} /> <span className="hidden sm:inline">Send</span>
        </button>
      </div>
    </div>
  );
}
